<script setup lang="ts">
import { usePayStore } from "../../store";

const payStore = usePayStore();

const getPaymentMethodIcon = (paymentMethod: string) => {
  switch (paymentMethod) {
    case "stripe":
    case "adyen":
      return "lds-icon-CreditCard";
    default:
      return "lds-icon-Banked";
  }
};
</script>

<template>
  <div data-testid="payment-selector-component">
    <h3>How would you like to pay?</h3>
    <div class="btn-wrapper">
      <button
        v-for="paymentMethod in payStore.availablePaymentMethods"
        :key="paymentMethod.external_provider_key"
        @click="() => payStore.handleMethodSelection(paymentMethod)"
      >
        <lds-icon
          :name="getPaymentMethodIcon(paymentMethod.external_provider_key)"
        ></lds-icon>
        {{ paymentMethod.label }}
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
h3 {
  margin: 0 0 $spacing-m 0;
  @include typography-h3;
  color: $color-neutral-900;
}
.btn-wrapper {
  button {
    display: block;
    width: 100%;
    text-align: left;
    @include typography-body-bold;
    color: $color-neutral-900;
    background-color: transparent;
    border: 1px solid $color-neutral-200;
    border-radius: 4px;
    padding: $spacing-s;
    display: flex;
    align-items: center;
    gap: $spacing-s;
    &:hover {
      cursor: pointer;
      background-color: $color-neutral-100;
    }
    &:nth-child(2) {
      margin-top: $spacing-s;
    }
  }
}
</style>
